import React, { useEffect, useRef } from 'react'
import { withRouter } from 'react-router-dom'
import { withAuth } from '../AuthContext'
import { SubtitleOpen } from '../Utils/CustomClasses'
import MyFreebirdDashboardDivider from './MyFreebirdDashboardDivider'
import styled from 'styled-components'

const DashboardRightContainer = styled.div`
  margin: 0 40px 0 0;
  display: block;
  width: -webkit-fill-available;
  border: 1px solid #f1eded;
  border-radius: 5px;

  @media screen and (max-width: 799px) {
    margin: 0 5% 0 5%;
    width: 90%;
  }
`

const DashboardRightTitleBox = styled.div`
  padding: 16px 20px 16px 25px;
`

const DashboardRightMainBox = styled.div`
  padding: 20px 25px 10px 25px;
`

const DashboardTitle = styled(SubtitleOpen)``

const MyFreebirdDashboardRight = ({ color, title, children }) => {
  return (
    <DashboardRightContainer>
      <DashboardRightTitleBox>
        {' '}
        <DashboardTitle
          color="#000"
          size="16px"
          sizemd="16px"
          sizesm="16px"
          lineheight="100%"
          weight="700"
          margin="0"
          dangerouslySetInnerHTML={{
            __html: `${title}:`,
          }}
        />
      </DashboardRightTitleBox>
      <MyFreebirdDashboardDivider color={color} />
      <DashboardRightMainBox>{children}</DashboardRightMainBox>
    </DashboardRightContainer>
  )
}

export default withRouter(withAuth(MyFreebirdDashboardRight))
